module.exports = __webpack_public_path__ + "img/phone_tablet.d1cb05fc.jpg";